import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: null,
};

const getRangeTimeKeepingSlice = createSlice({
  name: "getRangeTimeKeeping",
  initialState,
  reducers: {
    getRangeTimeKeepingStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getRangeTimeKeepingSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getRangeTimeKeepingFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetGetRangeTimeKeeping: (state) => initialState,
  },
});

export const {
  getRangeTimeKeepingStart,
  getRangeTimeKeepingSuccess,
  getRangeTimeKeepingFailed,
  resetGetRangeTimeKeeping,
} = getRangeTimeKeepingSlice.actions;

export default getRangeTimeKeepingSlice.reducer;
